import {MetricValue} from 'common/src/modules/analytics/analytics.types';

const ALL_VALUE = 'all';

const CAMPAIGN_METRICS: MetricValue[] = [
  MetricValue.Impressions,
  MetricValue.Clicks,
  MetricValue.ClickThroughRate,
  MetricValue.ClickThroughConversion,
  MetricValue.ViewThroughConversions,
  MetricValue.Conversions,
  MetricValue.Engagements,
  MetricValue.ConversionRate,
  MetricValue.Sales,
  MetricValue.Viewability,
  MetricValue.ViewedImpressions,
  MetricValue.VideoQ1,
  MetricValue.VideoQ2,
  MetricValue.VideoQ3,
  MetricValue.VideoComplete,
  MetricValue.Skip,
  MetricValue.VideoCompletionRate,
  MetricValue.CTCR,
  MetricValue.VTCR,
];

const CAMPAIGN_TABLE_COLUMN_KEY: Partial<Record<MetricValue, string>> = {
  [MetricValue.Impressions]: 'impressions',
  [MetricValue.Clicks]: 'clicks',
  [MetricValue.ClickThroughRate]: 'ctr',
  [MetricValue.ClickThroughConversion]: 'ctc',
  [MetricValue.ViewThroughConversions]: 'vtc',
  [MetricValue.Conversions]: 'conv',
  [MetricValue.Engagements]: 'engagements',
  [MetricValue.ConversionRate]: 'cr',
  [MetricValue.Sales]: 'sales',
  [MetricValue.Viewability]: 'viewability',
  [MetricValue.ViewedImpressions]: 'view_y',
  [MetricValue.VideoQ1]: 'firstQuarter',
  [MetricValue.VideoQ2]: 'secondQuarter',
  [MetricValue.VideoQ3]: 'thirdQuarter',
  [MetricValue.VideoComplete]: 'videoComplete',
  [MetricValue.Skip]: 'skip',
  [MetricValue.VideoCompletionRate]: 'vcr',
  [MetricValue.CTCR]: 'ctcr',
  [MetricValue.VTCR]: 'vtcr',
};

export {ALL_VALUE, CAMPAIGN_METRICS, CAMPAIGN_TABLE_COLUMN_KEY};
